module.exports = __webpack_public_path__ + "static/img/mobile_member_item_price_select_icon.0ebbae6c.png";